module.exports = __webpack_public_path__ + "images/skillzLogo-63c177c794cbc0a2b32402266ab46c2b.svg";